import { store } from '@/state/store';
import { on_workspaces_deleted } from '@/state/workspace/_methods/on_workspace_deleted';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { local_workspace_upsert } from '@/state/workspace/entity/local_workspace_upsert';
import { DTO__workspace } from '@shared/dto/+workspace/workspace_entity/DTO__workspace';
import { ENUM__network_event_server_to_client as ENE } from '@shared/network/ENUM__network_event_server_to_client';
import { add_socket_handler_client as add } from '../../_methods/add_socket_handler_client';
import { init_grid2d_possible_features_for_all_entities } from '../../_methods/init_grid2d_possible_features_for_all_entities';

export function add_socket_handlers_client_workspace() {
  add(ENE.WORKSPACE_ALL_DATA_LOADED, (value: boolean) => store.dispatch(LOCAL__workspace_set_is_all_data_loaded(value)));

  add(ENE.WORKSPACE_UPSERT, (items: DTO__workspace[]) => {
    store.dispatch(local_workspace_upsert(items));

    init_grid2d_possible_features_for_all_entities();
  });

  add(ENE.WORKSPACE_DELETE, async (ids: string[]) => await on_workspaces_deleted(ids));
}
